import _ from 'lodash'

export default {
    props: {
        modelId: {
            type   : Number,
            default: null
        },
        value  : {
            type   : Boolean,
            default: false
        },
    },
    data() {
        return {
            fromBackOrder        : null,
            units                : [],
            url                  : this.$getUrl('purchase-orders', this.value, this.modelId),
            axiosMethod          : this.$getAxiosMethod(this.value, this.modelId),
            forms                : this.$root.$data.forms,
            items                : [],
            menu1                : false,
            menu2                : false,
            modal                : false,
            dialog               : false,
            orders               : {},
            model10              : [],
            loading              : false,
            settings             : [],
            products             : [],
            suppliers            : [],
            tooltipId            : "conversionTooltip",
            warehouses           : [],
            product_id           : '',
            extra_weight         : 0,
            payment_type         : 1,
            computedDate         : null,
            supplierModal        : false,
            computedDate1        : null,
            searchProduct        : null,
            payment_status       : 1,
            purchasePrintData    : null,
            profitPercentageField: false,
        }
    },

    beforeCreate() {
        this.$root.$data.forms.fieldReset();
    },
    watch: {
        searchProduct(val) {
            if(val) {
                this.getProducts(val)
                val = null
            }
        },
        '$route.fullPath'(val) {
            //reset data

            this.forms.reset()
            this.orders     = {}
            this.product_id = ''
            this.items      = []
        },
    },

    computed: {
        isLoaded() {
            return !_.isEmpty(this.warehouses) || !_.isEmpty(this.suppliers) || !_.isEmpty(this.products) || !_.isEmpty(this.units)
        },
        total() {
            let total         = 0
            let shipping_cost = 0
            let discount      = 0
            shipping_cost     = !this.forms.shipping_cost ? 0 : this.forms.shipping_cost
            if(this.items.length > 0) {
                for (let i = 0; i < this.items.length; i++) {
                    total += this.items[i].price
                }
            }
            total    = parseFloat(total) + parseFloat(shipping_cost)
            discount = this.forms.overall_discount ? total * parseFloat(this.forms.overall_discount) / 100 : 0
            total -= discount
            this.getTotalWeight()
            return total.toFixed(4)
        },

    },

    created() {
        this.getData()
    },
    methods: {
        getData() {
            this.$set(this.forms, 'order_date', new Date())
            this.checkFromSaleOrder()
            this.loading = true
            this.$root.$data.erp.request.get(this.url, this, (data) => {
                this.settings          = data.settings
                this.suppliers         = data.suppliers
                this.products          = data.products
                this.warehouses        = data.warehouses
                this.units             = data.units
                this.forms.order_no    = data.latest_po
                this.forms.supplier_id = this.$root.getDefault_id(this.suppliers)
                if(this.axiosMethod === 'patch') {
                    this.orders           = data.order
                    this.forms.order_date = moment(this.orders.order_date).format("YYYY-MM-DD")
                    if(this.orders.expected_receive_date) {
                        this.forms.expected_receive_date = moment(this.orders.expected_receive_date, this.$root.settings.settings.date_format).format("YYYY-MM-DD")
                        this.computedDate1               = moment(this.forms.expected_receive_date, "YYYY-MM-DD").format(this.$root.settings.settings.date_format)
                    }
                    this.$root.$set(this.forms, 'overall_discount', this.orders.overall_discount);
                    this.$root.$set(this.forms, 'shipping_cost', this.orders.shipping_cost);
                    this.forms.supplier_id = parseInt(this.orders.supplier_id)
                    this.forms.order_no    = this.orders.order_no
                    for (let i = 0; i < this.orders.products.length; i++) {
                        let product = this.orders.products[i];
                        this.items.push({
                                            product_id  : product.id,
                                            pname       : product.name,
                                            unit_price  : parseFloat(product.pivot.price).toFixed(4),
                                            warehouse   : parseInt(product.pivot.warehouse_id),
                                            unit        : parseInt(product.pivot.unit_id),
                                            units       : product.units,
                                            discount    : product.pivot.discount,
                                            quantity    : product.pivot.quantity,
                                            fromUnit    : product.pivot.unit_id,
                                            baseUnit    : product.base_unit_id,
                                            price       : 0,
                                            weight      : product.pivot.weight,
                                            weight_total: product.pivot.weight_total
                                        });
                    }
                    this.getTotalWeight()
                    this.extra_weight = this.orders.total_weight - this.forms.total_weight
                }
                this.loading = false
            });
        },
        checkFromSaleOrder() {
            if(this.$route.name !== 'purchase.order.create' && this.$route.name !== 'purchase.order.edit' && !this.value) {
                this.getProducts(this.fromBackOrder.product_code)
            } else {
                this.fromBackOrder = null
            }

            // if(this.value && (this.axiosMethod!=='patch' && this.axiosMethod!=='create')){
            //     this.getProducts(this.fromBackOrder.product_code)
            // }else{
            //     this.fromBackOrder = null
            // }

        },
        getTotalWeight() {
            this.forms.total_weight = 0
            this.items.forEach(item => {
                if(!item.weight_total) {
                    item.weight_total = 0
                }
                this.forms.total_weight += item.weight_total
            })
        },
        itemTotalWeight(index) {
            this.items[index].weight_total = this.items[index].quantity
                ? this.items[index].weight * this.items[index].quantity
                : 0

            return this.items[index].weight_total
        },
        findWeight(product_id) {
            let product = this.getProduct(product_id)
            let units   = product.units
            if(units.length > 0) {
                let weight = units.find((unit) => {
                    return unit.id === product.base_unit_id
                }).pivot.weight
                return weight ? weight : 0;
            } else {
                return 0;
            }
            // console.log(_.find(this.getProduct(product_id).units, { id: this.getProduct(product_id).base_unit_id
            // }));
            // return _.find(this.getProduct(this.product_id).units, { id:
            // this.getProduct(this.product_id).base_unit_id }).pivot.weight
        },
        postOrder() {
            this.loading          = true
            this.forms.items      = this.items
            this.forms.total      = this.total
            this.forms.order_date = moment(this.forms.order_date).format("YYYY-MM-DD")
            if(this.forms.expected_receive_date) {
                this.forms.expected_receive_date = moment(this.forms.expected_receive_date).format("YYYY-MM-DD")
            }
            this.forms.extra_weight = this.extra_weight

            this.forms.submit(
                this.axiosMethod,
                this.$getUrlForm(this.url),
                false,
                this.$root
            )
                .then(data => {
                    this.forms.order_date = moment(new Date()).format("YYYY-MM-DD")
                    this.items            = []
                    this.loading          = false
                    Swal.fire({
                                  timer            : 3000,
                                  icon             : data.type,
                                  text             : data.message,
                                  showCancelButton : false,
                                  showConfirmButton: false,
                              })
                        .then((result) => {
                            if(!this.value && this.axiosMethod === 'patch') {
                                this.$router.push({name: 'purchase.order.index'})
                            }
                            if(!this.value && this.axiosMethod === 'create') {
                                this.getData()
                            }
                            if(!_.isEmpty(this.fromBackOrder)) {
                                this.$emit('fromBackOrder', data.purchase_order_object)
                            }
                            if(this.value) {
                                this.$emit('input', false)
                            }
                        })
                })
                .catch(error => {
                    this.loading = false
                });


        },
        // product Sale section
        addProduct() {
            if(!this.product_id) return null;
            if(!_.isEmpty(this.fromBackOrder)) {
                this.items.push({
                                    product_id    : parseInt(this.product_id),
                                    pname         : this.getProduct(this.product_id).name,
                                    unit_price    : parseFloat(this.getProduct(this.product_id).price).toFixed(4),
                                    price         : 0,
                                    warehouses    : this.getProduct(this.product_id).warehouses,
                                    warehouse     : this.fromBackOrder.warehouse,
                                    productInStock: this.getAvailableProductCount(this.getProduct(this.product_id).warehouses),
                                    fromUnit      : this.getProduct(this.product_id).base_unit_id,
                                    baseUnit      : this.getProduct(this.product_id).base_unit_id,
                                    units         : this.getProduct(this.product_id).units,
                                    unit          : this.fromBackOrder.unit,
                                    weight        : this.findWeight(this.product_id),
                                    quantity      : this.fromBackOrder.quantity
                                });
            } else {
                this.items.push({
                                    product_id    : parseInt(this.product_id),
                                    pname         : this.getProduct(this.product_id).name,
                                    unit_price    : parseFloat(this.getProduct(this.product_id).price).toFixed(4),
                                    price         : 0,
                                    warehouses    : this.getProduct(this.product_id).warehouses,
                                    warehouse     : this.$root.getDefault_id(this.warehouses),
                                    productInStock: this.getAvailableProductCount(this.getProduct(this.product_id).warehouses),
                                    fromUnit      : this.getProduct(this.product_id).base_unit_id,
                                    baseUnit      : this.getProduct(this.product_id).base_unit_id,
                                    units         : this.getProduct(this.product_id).units,
                                    unit          : this.$root.getPrimary_id(this.getProduct(this.product_id).units),
                                    weight        : this.findWeight(this.product_id)
                                });
            }


            if(this.items.length > 0) {
                this.product_id    = null
                this.searchProduct = null
            }
        },
        select_default_warehouse(warehouses) {
            let datas = null
            warehouses.filter(data => {
                if(data.is_default) {
                    datas = data.id
                }
            })
            if(!datas) {
                return warehouses[0].id
            } else {
                return datas
            }
        },
        uniqueItem(id) {
            return this.items.find((item) => {
                return item.product_id === id
            })
        },

        getProduct(id) {
            return this.products.find((product) => {
                return product.id === this.product_id
            })
        },
        getProductById(id) {
            return this.products.find((product) => {
                return product.id === id
            })
        },
        removeProduct(index) {
            this.items.splice(index, 1);
        },
        getTotalPrice(item) {
            let totalPrice = 0
            if(isNaN(item.quantity)) {
                return 'total: ' + totalPrice
                item.price = totalPrice
            } else {
                if(isNaN(item.discount)) {
                    totalPrice = (item.quantity * item.unit_price)
                } else {
                    totalPrice = (item.quantity * item.unit_price) - item.discount
                }
                item.price = totalPrice
                return 'total: ' + totalPrice
            }
        },
        getPrice(unit, index) {
            let fromUnit               = this.items[index].fromUnit
            this.items[index].fromUnit = unit
            if(fromUnit === unit) {
                return
            }

            let url = '/api/inventory/unitconversions/' + unit + '/' + fromUnit + '/1'
            axios.post(url)
                 .then(response => {
                     let conversion               = response.data.conversion
                     this.items[index].unit_price = parseFloat(response.data.quantity * this.items[index].unit_price).toFixed(4)

                 })
        },
        getAvailableProductCount(warehouses) {
            let quantity = 0
            for (var i = 0; i < warehouses.length; i++) {
                let warehouse = warehouses[i]
                quantity += parseFloat(warehouse.pivot.quantity)
            }
            return quantity
        },
        getNewCustomer(supplierDetails) {
            this.forms.order_date     = moment(new Date()).format("YYYY-MM-DD")
            this.forms.payment_status = 3
            this.forms.status         = 1
            this.suppliers.push(supplierDetails);
            this.forms.supplier_id = supplierDetails.id;
            this.dialog            = false
        },
        onCancel() {
            this.$router.push({name: "purchase.index"})

        },
        getProducts: _.debounce(function (query) {
            if(query !== '') {
                axios.post('/api/inventory/products/getProducts', {val: query, isPurchase: true})
                     .then(response => {
                         this.products = response.data.products
                         if(this.products.length === 1) {
                             this.product_id = this.products[0].id
                             this.addProduct()
                             this.products = []
                         }
                         this.loading = false
                     })
                     .catch(error => {
                     })
            } else {
                this.loading  = true;
                this.products = []
                return null
            }
        }, 1000),
        // getProducts(query) {
        //     if (query !== '') {
        //         setTimeout(() => {
        //             axios.post('/api/inventory/products/getProducts', {val: query, isSale: true})
        //                 .then(response => {
        //                     this.products = response.data.products
        //                     this.loading = false;
        //                 })
        //                 .catch(error => {
        //                     alert(error.message)
        //                 })
        //         }, 200);
        //     } else {
        //         this.loading = true;
        //         this.products = []
        //         return null
        //     }
        // },
        getInputField(event) {
            this.profitPercentageField = event.target.checked

        },
        initPreview() {
            Erp.salePurchase.initialPreviewSetup(this)
        },
        closeDatePicker1() {
            let currentTime                  = moment(new Date()).format("HH:mm:ss")
            let expected_receive_date        = this.forms.expected_receive_date
            let selectedDate                 = moment(expected_receive_date).format(this.$root.settings.settings.date_format)
            // console.log(selectedDate + ' ' + currentTime)
            this.computedDate1               = moment(selectedDate + ' ' + currentTime, this.$root.settings.settings.date_format).format(this.$root.settings.settings.date_format)
            this.forms.expected_receive_date = moment(this.forms.expected_receive_date + ' ' + currentTime).format("YYYY-MM-DD")
            this.menu2                       = false
        }
    }
}